module.exports = __webpack_public_path__ + "img/logo_abinizm.7d9e5087.jpg";